var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 58.6484C13.0136 58.6484 0 45.6377 0 29.6548C0 13.672 13.0136 0.648438 29 0.648438C44.9864 0.648438 58 13.6592 58 29.6421C58 45.6249 44.9991 58.6484 29 58.6484ZM29 2.54903C14.0598 2.54903 1.90101 14.7052 1.90101 29.6421C1.90101 44.5789 14.0598 56.7351 29 56.7351C43.9402 56.7351 56.099 44.5789 56.099 29.6421C56.099 14.7052 43.9529 2.54903 29 2.54903Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1912 43.4223L27.4595 33.307L18.6052 43.4223H14.8159L25.6861 30.9983L14.127 15.8828H23.0706L30.075 25.1434L38.1767 15.8828H41.9659L31.8229 27.465L43.8925 43.4095H35.1912V43.4223ZM36.1353 41.3048H39.7587L21.9989 17.8344H18.1841L36.1353 41.3048Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.105065e91bde3d8b5247a9fff8a5cff5.svg";
export { ForwardRef as ReactComponent };